/**
 * PLATFORM İŞLEMİ → KART TÜRÜ yönlendirmesi (Faz 8, 30 Eyl 2026).
 *
 * Katalog okuma operasyonunun sonucu sohbette hangi kartla çizilir? Alan
 * dosyaları (`analysis.ts` …) `*_OP_CARDS` listelerinde desen → tür satırı
 * tutar; API üreticisi (`apps/api/src/agent/cards/<alan>/`) AYNI deseni ve
 * türü kullanır (`cards.spec.ts` ikisini karşılaştırıyor), web
 * `hasToolRenderer` bu listeden okur.
 *
 * Desen: tam kimlik (`meta.ad.preview`) ya da nokta bölümlü joker —
 * `*` tek bölüm (`*.comment.list` → beş platformun yorum listesi), `**` bir
 * ya da daha çok bölüm (`meta.insights.**`). Katalog BURAYA import edilmez:
 * web paketi 1100+ şemalı kataloğu taşımamalı.
 */
export interface OpCardRoute<K extends string = string> {
  match: string;
  kind: K;
}

const cache = new Map<string, RegExp>();

/** Desen → düzenli ifade (önbellekli). */
function patternOf(match: string): RegExp {
  let re = cache.get(match);
  if (!re) {
    const body = match
      .split('.')
      .map((part) =>
        part === '**'
          ? '[^.]+(?:\\.[^.]+)*'
          : part === '*'
            ? '[^.]+'
            : part.replace(/[-/\\^$+?()|[\]{}]/g, '\\$&'),
      )
      .join('\\.');
    re = new RegExp(`^${body}$`);
    cache.set(match, re);
  }
  return re;
}

/** Operasyon kimliği desene uyuyor mu. */
export function opMatches(match: string, opId: string): boolean {
  return patternOf(match).test(opId);
}

/**
 * Araç adı (`meta__campaign__list`) → operasyon kimliği; katalog doğrulaması
 * YOK (web). Operasyon aracı değilse `null`.
 */
export function opIdOfToolName(name: string): string | null {
  return name.includes('__') ? name.replace(/__/g, '.') : null;
}
